module.exports = __webpack_public_path__ + "static/media/Week 4 Monday.14c1fe15.png";